/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import { union } from '@ember/object/computed';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class ProgressController extends Controller {
  @service
  router;

  @service
  dates;

  @tracked
  report = 'dots';
  @tracked
  subjectId = '';
  reports1 = [
    {
      key: 'latest',
      label: 'Latest snapshot',
      route: 'latest',
      icon: 'eye',
    },
    {
      key: 'progress',
      label: 'Progress',
      route: 'progress.subject',
      icon: 'chart',
    },
    {
      key: 'rates',
      label: 'Rates of Progress',
      route: 'rates.subject',
      icon: 'show_chart',
    },
  ];

  @computed('model.milestones.[]', 'thisYear')
  get reports2() {
    // Start with the static report types.
    let reports = [
      {
        key: 'overview',
        label: 'Overview',
        route: 'overview',
      },
      {
        key: 'dots',
        label: 'Dots',
        route: 'dots',
      },
    ];
    if (this.model.milestones.length || this.model.milestoneSets.length) {
      // For each of the past 3 years (including this year), add mid/end breakdowns.
      [
        this.dates.currentAcademicYearLabel,
        this.dates.previousAcademicYearLabel,
        this.dates.previousPreviousAcademicYearLabel,
      ].forEach((year) => {
        reports.push({
          key: `${year}end`,
          label: `End ${year}`,
          route: 'breakdown',
          params: {
            year,
            type: 'end',
          },
        });
        reports.push({
          key: `${year}mid`,
          label: `Mid ${year}`,
          route: 'breakdown',
          params: {
            year,
            type: 'mid',
          },
        });
      });
    }

    return reports;
  }

  @union('reports1', 'reports2')
  reports;

  transitionToReport() {
    let report = findBy(this.reports, 'key', this.report);
    if (!isEmpty(report.params)) {
      let opts = {
        queryParams: report.params,
      };
      this.router.transitionTo(
        `group.insights.progress.${report.route}`,
        this.model.group.id,
        this.subjectId,
        opts,
      );
    }
    if (report.key === 'latest') {
      this.router.transitionTo(`group.insights.progress.${report.route}`);
      return;
    }

    this.router.transitionTo(
      `group.insights.progress.${report.route}`,
      this.model.group.id,
      this.subjectId,
    );
  }

  @action
  setSubject(subject) {
    this.subjectId = subject.id;
    this.transitionToReport();
  }

  @action
  setReport(report) {
    this.report = report.key;
    this.transitionToReport();
  }
}
